<template>
    <v-app>
        <!-- main appbar -->
        <v-app-bar
            app
        >
            <!-- btn drawer -->
            <v-spacer>
                <a href="#"
                    title="Ayuda" target="_blank" class="btn btn-sm py-0 pt-2 d-block" style="font-size: 1.5em;"
                    @click.prevent="showTutoriales"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width=25 height=25 >
                        <path fill="white" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3" />
                        <path fill="red" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                    </svg>
                </a>
            </v-spacer>

            <!-- my site -->
            <v-btn
                icon
                target="_blank"
                :href="`/${slug}`"
                v-if="slug!=''"
            >
                <v-icon>mdi-web</v-icon>
            </v-btn>
            <!-- my site end -->

            <!-- menu account -->
            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        class="mr-0"
                    >
                        <v-icon>mdi-account-circle</v-icon>
                    </v-btn>
                </template>
                <v-list dense min-width="250px" max-height="250px">
                    <v-list-item>
                        <v-list-item-avatar>
                            <img
                                src="/images/user-default.png"
                                alt="admin"
                                style="object-fit:cover; object-position:center;"
                            >
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{ userName }}</v-list-item-title>
                            <v-list-item-subtitle>Preventista</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <!-- <v-list-item href="/seller/dashboard">
                        <v-icon>mdi-cube</v-icon>
                        <v-list-item-title>Products</v-list-item-title>
                    </v-list-item>
                    <v-list-item href="/seller/my-account">
                        <v-icon>mdi-account-edit</v-icon>
                        <v-list-item-title>Mi cuenta</v-list-item-title>
                    </v-list-item> -->
                    <v-list-item @click="dialogSales=!dialogSales">
                        <v-icon>mdi-basket</v-icon> &nbsp;
                        Mis preventas
                    </v-list-item>
                    <v-list-item href="/logout" @click.prevent="logout">
                        <v-icon>mdi-logout</v-icon>
                        <v-list-item-title>Cerrar sesión</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
            <!-- end menu account -->

        </v-app-bar>
        <!-- end main appbar -->

        <v-main class="grey lighten-3">
            <slot/>
        </v-main>

        <!-- ventas -->
        <v-dialog
            v-model="dialogSales"
            width="1200"
            overlay-opacity=".9"
        >
            <my-sales money="Bs." type-resp="presales" :slug="slug"></my-sales>
        </v-dialog>
        <!-- ventas END -->

        <v-footer
            app
            inset
        >
            <v-container>
                <span>Quick &copy; {{ new Date().getFullYear() }}</span>
            </v-container>
        </v-footer>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity="1" z-index="10" color="grey lighten-3">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            overlay: false,
            // ventas
            dialogSales: false
        }
    },
    props: ['userId','userName', 'slug'],
    mounted() {
        setTimeout(() => {
            this.overlay = false
        }, 500);
    },
    methods: {
        // end notifications
        async logout () {
            await axios.post(`/logout`)
            .then((response) => {
                if (response.status === 204) {
                    location.reload();
                }
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        showTutoriales() {
            try {
                let info = {
                    platform: "cat",
                    user_id: parseInt(this.userId)
                };
                let info_encoded = btoa(JSON.stringify(info));
                window.open(
                    `https://one.quick.com.bo/tutorials?info=${info_encoded}`,
                    'tutorials',
                    'width=800,height=400,menubar=no,toolbar=no,location=no,status=no,scrollbars=no,resizable=no'
                );
            } catch (error) { console.log(error); }
        }
    },
}
</script>
